import { render } from "./SchoolCreateView.vue?vue&type=template&id=ba8afd30"
import script from "./SchoolCreateView.vue?vue&type=script&lang=js"
export * from "./SchoolCreateView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dashboard.epsasport-dev.apps.lu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__